import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useConfigStore } from "@/stores/config";
import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { getFormattedDateStringNoTime } from "@/composables/dateField";
import { getElementReport } from "@/composables/elementsHierarchy";
import { styles } from "@/reports/reportStyles";

function setTunnelsDocDefinition(structure) {
  const configStore = useConfigStore();
  const content = getElementReport(structure);

  let docDefinition = {
    header: function () {
      return getReportHeader("Tunnels Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "Tunnels Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Tunnel Details",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 10, 0, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Structure Type and Material Items",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["32%", "20%", "28%", "*"],
          body: [
            [
              { text: "S.1 Number of Bores: ", bold: true },
              {
                text: structure?.structureTunnelMaterial?.numBores,
              },
              { text: "S.4 Ground Condition: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.GROUND_CONDITION,
                  structure?.structureTunnelMaterial?.groundCondition
                ),
              },
            ],
            [
              { text: "S.2 Tunnel Shape: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.TUNNEL_SHAPE,
                  structure?.structureTunnelMaterial?.tunnelShape
                ),
              },
              { text: "S.5 Complex: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.COMPLEX,
                  structure?.structureTunnelMaterial?.complex
                ),
              },
            ],
            [
              { text: "S.3 Portal Shape: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.PORTAL_SHAPE,
                  structure?.structureTunnelMaterial?.portalShape
                ),
              },
              "",
              "",
            ],
          ],
        },
        margin: [20, 10, 20, 0],
        layout: "noBorders",
      },

      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Age and Service Items",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["32%", "20%", "28%", "*"],
          body: [
            [
              { text: "A.8 Service in Tunnel: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.SERVICE_IN_TUNNEL,
                  structure?.tunnelService?.svcInTunnel
                ),
              },
              "",
              "",
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Classification Items",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["32%", "20%", "28%", "*"],
          body: [
            [
              { text: "C.3 Direction of Traffic: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.DIRECTION_OF_TRAVEL,
                  structure?.tunnelService?.dirOfTraffic
                ),
              },
              { text: "C.7 Functional Classification: ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.TUNNEL_FUNCTIONAL_CLASSIFICATION,
                  structure?.tunnelService?.functionalClass
                ),
              },
            ],
            [
              { text: "C.4 Toll: ", bold: true },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.TOLL, structure?.tunnelService?.toll),
              },
              { text: "C.8 Urban Code: ", bold: true },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.URBAN_CODE, structure?.tunnelService?.urbanCode),
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Inspection Items",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["32%", "20%", "28%", "*"],
          body: [
            [
              { text: "D.1 Routine Insp Target Date: ", bold: true },
              {
                text: getFormattedDateStringNoTime(structure?.tunnelService?.inspTargetDate),
              },
              { text: "D.4 In-Depth Insp Scheduled? ", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.IN_DEPTH,
                  structure?.tunnelService?.inDepthInspSchedule
                ),
              },
            ],
            [
              { text: "D.5 Damage Insp Performed?", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.DAMAGE_PERFORMED,
                  structure?.tunnelService?.damageInspPerformed
                ),
              },
              { text: "D.6 Special Insp Scheduled?", bold: true },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.IN_DEPTH,
                  structure?.tunnelService?.specialInspScheduled
                ),
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Posting Restriction Items",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },
      {
        table: {
          headerRows: 0,
          widths: ["32%", "20%", "28%", "*"],
          body: [
            [
              { text: "L.10 Height Restriction: ", bold: true },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.YES_NO, structure?.tunnelLoadRating?.heightRestr),
              },
              { text: "L.12 Other Restrictions: ", bold: true },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.YES_NO, structure?.tunnelLoadRating?.otherRestr),
              },
            ],
            [
              { text: "L.11 Hazardous Mat'l Restriction: ", bold: true },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.YES_NO, structure?.tunnelLoadRating?.hazmatRestr),
              },
              "",
              "",
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 10, 20, 0],
      },

      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Elements",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 10, 0, 0],
      },
      content.map((a) => a),
    ],
    styles: styles,
    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

export { setTunnelsDocDefinition };
